import React from 'react';
import { PropTypes } from 'prop-types';

import { Alert, AlertTitle } from '@material-ui/lab';

function Error(props) {
  const { isTest } = props;
  return (
    <div>
      <Alert severity="warning">
        <AlertTitle>Missing Key</AlertTitle>
        {isTest && (
          <div>
            Please add a
            <strong> webwidget </strong>
            channel under
            <strong> Publish </strong>
            page to activiate this testing component
          </div>
        )}
      </Alert>
    </div>
  );
}

Error.propTypes = {
  isTest: PropTypes.bool.isRequired,
};

export default Error;
